import { createRouter, createWebHashHistory } from "vue-router";
import axios from "axios";

const routes = [
  {
    path: "/",
    name: "home",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/HomeViewRev1.vue"),
  },
  // rute -ref lama di-redirect ke rute utama (halaman Rev1 sudah dipromosikan)
  {
    path: "/home-ref",
    redirect: "/",
  },
  {
    path: "/home-v2",
    name: "homeV2",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/HomeViewV2.vue"),
  },
  {
    path: "/home-v3",
    name: "homeV3",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/HomeViewV3.vue"),
  },
  {
    path: "/home-v4",
    name: "homeV4",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/HomeViewV4.vue"),
  },
  {
    path: "/home-v5",
    name: "homeV5",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/HomeViewV5.vue"),
  },
  {
    path: "/home-v6",
    name: "homeV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/HomeViewV6.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/ProfileViewRev1.vue"),
  },
  {
    path: "/profile-ref",
    redirect: "/profile",
  },
  {
    path: "/profile-v6",
    name: "profileV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/ProfileViewV6.vue"),
  },
  {
    path: "/faq",
    name: "faq",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/FAQViewRev1.vue"),
  },
  {
    path: "/faq-ref",
    redirect: "/faq",
  },
  {
    path: "/contact",
    name: "contact",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/contact-confirm",
    name: "contactConfirm",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/ContactConfirmView.vue"),
  },
  {
    path: "/concrete",
    name: "concrete",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/ProductConcrete.vue"),
  },
  {
    path: "/concrete-v6",
    name: "concreteV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/ProductConcreteV6.vue"),
  },
  {
    path: "/mine",
    name: "mine",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/ProductMine.vue"),
  },
  {
    path: "/mine-v6",
    name: "mineV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/ProductMineV6.vue"),
  },
  {
    path: "/article",
    name: "article",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/MediaArticleRev1.vue"),
  },
  {
    path: "/article-ref",
    redirect: "/article",
  },
  {
    path: "/article-v6",
    name: "articleV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/MediaArticleV6.vue"),
  },
  {
    path: "/article-detail/:id",
    name: "articleDetail",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/MediaArticleDetailRev1.vue"),
  },
  {
    path: "/article-detail-ref/:id",
    redirect: (to) => `/article-detail/${to.params.id}`,
  },
  {
    path: "/article-detail-v6/:id",
    name: "articleDetailV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/MediaArticleDetailV6.vue"),
  },
  {
    path: "/news",
    name: "news",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/MediaNewsRev1.vue"),
  },
  {
    path: "/news-ref",
    redirect: "/news",
  },
  {
    path: "/news-v6",
    name: "newsV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/MediaNewsV6.vue"),
  },
  {
    path: "/news-detail/:id",
    name: "newsDetail",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/MediaNewsDetailRev1.vue"),
  },
  {
    path: "/news-detail-ref/:id",
    redirect: (to) => `/news-detail/${to.params.id}`,
  },
  {
    path: "/news-detail-v6/:id",
    name: "newsDetailV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/MediaNewsDetailV6.vue"),
  },
  {
    path: "/gallery",
    name: "gallery",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/MediaGalleryRev1.vue"),
  },
  {
    path: "/gallery-ref",
    redirect: "/gallery",
  },
  {
    path: "/gallery-v6",
    name: "galleryV6",
    meta: {
      noAuth: true,
      ownFooter: true,
    },
    component: () => import("../views/MediaGalleryV6.vue"),
  },
  {
    path: "/about",
    name: "about",
    meta: {
      noAuth: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },

  // login
  {
    path: "/login",
    name: "Login",
    meta: {
      noAuth: true,
    },
    component: () => import("../views/Login.vue"),
  },
  // CMS
  {
    path: "/manage-carousel",
    name: "ManageCarousel",
    component: () => import("../views/CMS/ManageCarousel.vue"),
  },
  {
    path: "/manage-testimony",
    name: "ManageTestimony",
    component: () => import("../views/CMS/ManageTestimony.vue"),
  },
  {
    path: "/manage-consult",
    name: "ManageConsultation",
    component: () => import("../views/CMS/ManageConsultation.vue"),
  },
  {
    path: "/manage-gallery",
    name: "ManageGallery",
    component: () => import("../views/CMS/ManageGallery.vue"),
  },
  {
    path: "/manage-article",
    name: "ManageArticle",
    component: () => import("../views/CMS/ManageArticle.vue"),
  },
  {
    path: "/manage-article-form",
    name: "ManageArticleForm",
    component: () => import("../views/CMS/ManageArticleForm.vue"),
  },
  {
    path: "/manage-news",
    name: "ManageNews",
    component: () => import("../views/CMS/ManageNews.vue"),
  },
  {
    path: "/manage-news-form",
    name: "ManageNewsForm",
    component: () => import("../views/CMS/ManageNewsForm.vue"),
  },
  {
    path: "/manage-catalog",
    name: "ManageProductCatalog",
    component: () => import("../views/CMS/ManageProductCatalog.vue"),
  },
  {
    path: "/manage-product-form",
    name: "ManageProductForm",
    component: () => import("../views/CMS/ManageProductForm.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  // next();
  // return;
  let temp_token = null;
  if (process.env.NODE_ENV == "development") {
    // next();
    // ADMIN
    // temp_token =
    //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluIiwiaWF0IjoxNzA1ODkzODc3LCJleHAiOjE3MDYxNTMwNzd9.-JHH2tzqzVoo5bkx6ROxExs3IBk3z-7knCYEefA_Qjk";
  }

  let token = localStorage.getItem(process.env.VUE_APP_TOKEN_NAME);
  // token = null;
  if (to.meta.noAuth) {
    next();
  } else if (token === null) {
    // console.log("no token");
    next("/login");
  } else {
    // console.log(token);
    try {
      let resp = await axios.post(
        `${process.env.VUE_APP_BASE_URL}/user/user_data`,
        {
          token: token,
        },
      );
      // console.log(resp.data);
      to.meta.user = resp.data;
      // next();
      if (to.meta?.access == null) {
        next();
      } else {
        next();

        // let access = checkAccess(resp.data, to.meta.access);
        // if (access) {
        //   next();
        // } else {
        //   next("/noaccess");
        // }
      }
    } catch (error) {
      console.log(error);
      console.log("gagal menarik data user");
      localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
      let redirect_url = to.fullPath;
      redirect_url = encodeURIComponent(redirect_url);
      next(`/login?redirect_url=${redirect_url}`);
    }
  }
});

export default router;
